import { useEffect, useState } from "react";

import Skeleton from "@/components/shared/Skeleton";

/**
 * One screenshot. An <img src> carries no Authorization header, so the bytes
 * are fetched as a blob and shown through an object URL, revoked on unmount.
 * `fetchImage` is the side's own read: FeedbackService.fetchImage for the
 * SuperAdmin queue, fetchTenantImage for a tenant's users.
 */
const Screenshot = ({ feedbackId, imageId, index, fetchImage }) => {
  const [state, setState] = useState({ url: null, failed: false });

  useEffect(() => {
    let alive = true;
    let url = null;
    fetchImage(feedbackId, imageId)
      .then((blob) => {
        url = URL.createObjectURL(blob);
        if (alive) setState({ url, failed: false });
      })
      .catch(() => alive && setState({ url: null, failed: true }));
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [feedbackId, imageId, fetchImage]);

  if (state.failed) {
    return <div className="flex h-40 items-center justify-center rounded-lg border border-border-primary text-xs text-text-secondary">Couldn't load this image.</div>;
  }
  if (!state.url) return <Skeleton className="h-40 w-full rounded-lg" />;
  return (
    <a href={state.url} target="_blank" rel="noreferrer" aria-label={`Open screenshot ${index + 1} full size`}>
      <img src={state.url} alt={`Screenshot ${index + 1}`} className="h-40 w-full rounded-lg border border-border-primary object-cover" />
    </a>
  );
};

// The screenshots a feedback was sent with, two to a row; nothing when none.
export const Screenshots = ({ feedback, fetchImage }) =>
  feedback.image_ids?.length > 0 && (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {feedback.image_ids.map((imageId, index) => (
        <Screenshot key={imageId} feedbackId={feedback.id} imageId={imageId} index={index} fetchImage={fetchImage} />
      ))}
    </div>
  );

export default Screenshot;
